import { fetchWrapper, objectToQueryParams } from '../utils';

const baseUrl = process.env.REACT_APP_BASE_API + 'client/beneficiaries';

export const create = async (form) => {
  return await fetchWrapper.post(baseUrl, form);
}

export const get = async (filters) => {
  const url = `${baseUrl}?${objectToQueryParams(filters)}`;
  return await fetchWrapper.get(url);
}

export const update = async (form) => {
  return await fetchWrapper.patch(baseUrl, form);
}

export const remove = async (id) => {
  const url = `${baseUrl}/${id}`;
  return await fetchWrapper.delete(url);
}
